import ContactHelpers from '../helpers/ContactHelpers'
import DataHelpers from '../helpers/DataHelpers'

import Vue from 'vue'
import StringHelpers from './StringHelpers'

export default class {

    static tagsToString(tagsObj) {
        return this.tagsToArray(tagsObj).join(', ')
    }

    static tagsToArray(tagsObj) {
        let tagsArr = []
        for(let prop in tagsObj) {
            tagsArr.push(StringHelpers.camelToNormal(prop))
        }
        return tagsArr
    }

    static addTag(tagObj, name, options = {}) {
        let tagName = StringHelpers.toCamelCase(name)

        //count only updated if the tag didn't already exist...
        const updateCount = (tagObj[tagName] ?  0 : 1)

        Vue.set(tagObj, tagName, true)

        return updateCount
    }


    static addTagToItems(tagItem, items) {
        
        let result = {added:0, existed:0}
        items.forEach(item => {
            if( this.addTag(item.tags, tagItem.name) )
                result.added += 1
            else
                result.existed += 1

        })
        result.message = (result.added ? result.added.toString() + ' members added. ' : '') + 
                    (result.existed ? result.existed.toString() + ' already existed.' : '')
        
        Vue.set(tagItem, 'members', (tagItem.members || 0) + result.added)

        return result
    }

    static removeTag(tagObj, name, options = {}) {
        let tagName = StringHelpers.toCamelCase(name)

        //count only updated if the tag existed...
        const updateCount = (tagObj.hasOwnProperty(tagName) ?  1 : 0)

        Vue.delete(tagObj, tagName)

        return updateCount
    }

    static removeTagFromItems(tagItem, items) {
        let result = {removed:0, omitted:0}
        items.forEach(item => {
            if( this.removeTag(item.tags, tagItem.name) )
                result.removed += 1
            else
                result.omitted += 1

        })
        result.message = (result.removed ? result.removed.toString() + ' members removed. ' : '') + 
                    (result.omitted ? result.omitted.toString() + ' omitted.' : '')

        let newMemberCount = tagItem.members - result.removed
        if(newMemberCount < 1) 
            newMemberCount = 0
        
        Vue.set(tagItem, 'members', newMemberCount)

        return result
    }

    static tagExists(tagObj, name) {
        const tagName = StringHelpers.toCamelCase(name)
        if(!tagObj)
            return false
        return !!tagObj[tagName]
    }

    static tagDate(tagObj, name) {
        const tagName = StringHelpers.toCamelCase(name) + 'Date'

        if(!tagObj)
            return null
        return tagObj[tagName] || null
    }

    static tagUser(tagObj, name) {
        const tagName = StringHelpers.toCamelCase(name) + 'User'

        if(!tagObj)
            return null
        return tagObj[tagName] || null
    }

    //Arrays

    static itemsWithTag(arr, tagName) {
        return arr.filter(o => o.tags && o.tags[tagName])
    }

    static itemsWithoutTag(arr, tagName) {
        return arr.filter(o => !o.tags || !o.tags[tagName])
    }
}


// WEBPACK FOOTER //
// ./src/helpers/TagHelpers.js